import React from 'react'
import { CButton } from '../../../../components/CButton'

type ViewDatasetDescriptionProps = {
  text: string
  onOpenEdit: () => void
}
export const ViewDatasetDescription: React.FC<ViewDatasetDescriptionProps> = ({ text, onOpenEdit }) => {
  return (
    <div style={{ maxHeight: '75vw' }}>
      {text}
      <div style={{ margin: '12px auto' }}>
        <CButton variant="outlined" label="Edit description" onClick={onOpenEdit} />
      </div>
    </div>
  )
}
